<nav attr.aria-label="{{ 'wcag.topMenu' | translate }}" id="topMenu">
  <ul class="list-inline mb-0">
    <li class="list-inline-item">
      <user-role-switcher
        (showUserRoleSwitcher)="setShowUserRoleSwithcher($event)"
        [collapsible]="true"
        [truncateLength]="8"
      ></user-role-switcher>
    </li>

    <li class="list-inline-item" *ngIf="!(member$ | async)">
      <language-switcher></language-switcher>
    </li>
    <li
      class="list-inline-item"
      *ngIf="showCartButton"
      data-test-id="cart-logo-primary-header"
    >
      <cart-block></cart-block>
    </li>
    <ng-container *ngIf="member$ | async as member">
      <li class="list-inline-item" *ngIf="member.status !== 3">
        <!-- dropdown -->
        <div class="position-relative" dropdown>
          <button
            *ngIf="configurationService.isTabletOrLarger$ | async"
            dropdownToggle
            type="button"
            data-test-id="logged-user-navbar-button"
            class="btn btn-soft-secondary dropdown-toggle"
            aria-controls="MemberName"
          >
            <i
              class="fas fa-user-circle me-2"
              aria-hidden="true"
              role="img"
            ></i>
            <span
              class="d-none d-md-inline-block"
              *ngIf="member$ | async as member"
              >{{ member.firstName }}</span
            >
          </button>
          <button
            *ngIf="!(configurationService.isTabletOrLarger$ | async)"
            dropdownToggle
            type="button"
            data-test-id="logged-user-navbar-button"
            class="btn btn-soft-primary dropdown-toggle avatar-button"
            aria-controls="MemberName"
          >
            <span *ngIf="member$ | async as member"
              >{{ member.firstName?.charAt(0)
              }}{{ member.lastName?.charAt(0) }}</span
            >
          </button>
          <ul
            id="MemberName"
            *dropdownMenu
            class="dropdown-menu dropdown-menu-right"
            role="menu"
          >
            <li role="menuitem">
              <!-- goes to orders, subscriptions etc ..-->
              <a
                class="dropdown-item"
                [routerLink]="appRoutesNS.Members.PROFILE_MYPROFILE"
                data-test-id="my-profile-dropdown-option"
                (click)="ticketingReset.emit()"
                (keyup.enter)="ticketingReset.emit()"
                href="javascript:;"
              >
                <i
                  class="fa fa-id-card me-2 fa-fw"
                  aria-hidden="true"
                  role="img"
                ></i>
                {{ 'general.myProfile' | translate }}
              </a>
            </li>
            <li role="menuitem" *ngIf="showMyShoppingInMobile$() | async">
              <!-- goes to account settings -->
              <a
                class="dropdown-item"
                [routerLink]="appRoutesNS.Members.PROFILE_MYSHOPPING"
                data-test-id="my-shopping-dropdown-option"
                (click)="ticketingReset.emit()"
                href="javascript:;"
              >
                <i
                  class="fa fa-shopping-basket me-2 fa-fw"
                  aria-hidden="true"
                  role="img"
                ></i>
                {{ 'memberModule.myShopping' | translate }}
              </a>
            </li>
            <li role="menuitem" *ngIf="showShopInMobile$() | async">
              <a
                class="dropdown-item"
                [routerLink]="appRoutesNS.Shop.SHOP"
                data-test-id="shop-dropdown-option"
                (click)="ticketingReset.emit()"
                href="javascript:;"
              >
                <i
                  class="fa fa-shopping-cart me-2 fa-fw"
                  aria-hidden="true"
                  role="img"
                ></i>
                {{ 'general.shop' | translate }}
              </a>
            </li>
            <li role="menuitem" *ngIf="showMyWorkInMobile$() | async">
              <a
                class="dropdown-item"
                [routerLink]="appRoutesNS.MyWork.MY_WORK"
                data-test-id="my-work-dropdown-option"
                (click)="ticketingReset.emit()"
                href="javascript:;"
              >
                <i
                  class="fa fa-laptop-house me-2 fa-fw"
                  aria-hidden="true"
                  role="img"
                ></i>
                {{ 'myWorkModule.myWork' | translate }}
              </a>
            </li>
            <li
              role="menuitem"
              *ngIf="moduleConfigs.serieProposalModule?.isActive"
            >
              <!-- goes to member's proposals -->
              <a
                class="dropdown-item"
                [routerLink]="appRoutesNS.Members.PROFILE_MYSERIEPROPOSALS"
                (click)="ticketingReset.emit()"
                href="javascript:;"
              >
                <i
                  class="fa fa-calendar me-2 fa-fw"
                  aria-hidden="true"
                  role="img"
                ></i>
                {{ 'serieProposalModule.mySerieProposals' | translate }}
              </a>
            </li>
            <li><hr class="dropdown-divider" /></li>
            <li role="menuitem">
              <a
                class="dropdown-item"
                [routerLink]="appRoutesNS.Members.PROFILE_CONTACT_US"
                (click)="ticketingReset.emit()"
                href="javascript:;"
              >
                <i class="fas fa-at me-2" aria-hidden="true" role="img"></i>
                {{ 'general.contactus' | translate }}
              </a>
            </li>
            <li><hr class="dropdown-divider" /></li>
            <li role="menuitem">
              <a
                class="dropdown-item"
                (click)="
                  logout.emit(); ticketingservice.actualTicketingStep = 0
                "
                data-test-id="log-out-dropdown-icon"
                href="javascript:;"
              >
                <i
                  class="fa fa-sign-out-alt me-2 fa-fw"
                  aria-hidden="true"
                  role="img"
                ></i>

                {{ 'general.logout' | translate }}
              </a>
            </li>
          </ul>
        </div>
        <!-- END dropdown -->
      </li>

      <li class="list-inline-item" *ngIf="member.status === 3">
        <button
          class="btn btn-primary"
          (click)="goLogin.emit()"
          type="button"
          data-test-id="unauthenticated-shopping-login-button"
        >
          {{ 'general.login' | translate }}
        </button>
      </li>
    </ng-container>

    <ng-container *ngIf="!(member$ | async)">
      <li class="list-inline-item">
        <button
          class="btn btn-primary"
          (click)="goLogin.emit()"
          type="button"
          data-test-id="login-button"
        >
          {{ 'general.login' | translate }}
        </button>
      </li>
    </ng-container>
  </ul>
</nav>
